import { Link } from 'react-router-dom';
import { LogIn } from 'lucide-react';

/**
 * Friendly signed-out state for gated pages (staff/admin), instead of a bare
 * "Please sign in." line. Centered card with a clear call to action.
 */
export default function SignInPrompt({
  title = 'Sign in to continue',
  message = 'You need to be signed in to view this page.',
}: {
  title?: string;
  message?: string;
}) {
  return (
    <div className="signin-prompt">
      <span className="signin-prompt-icon">
        <LogIn size={24} />
      </span>
      <h2>{title}</h2>
      <p className="muted">{message}</p>
      <Link to="/sign-in" className="btn primary">
        Sign in
      </Link>
    </div>
  );
}
